import { Box } from "@mui/material";
import StartStep from "./StartStep";
import { IStepItem } from "../../GraphicalStatus";

interface Props {
  items: IStepItem[];
}
export default function ProgressContent(props: Props) {
  const { items } = props;

  return (
    <Box
      sx={{
        display: "flex",
        paddingBottom: "8px",
        borderRadius: "8px",
        paddingX: "6px",
        gap: "3px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          paddingY: "6px",
          width: "100%",
        }}
      >
        {items.map((item) => (
          <StartStep {...item} />
        ))}
      </Box>
    </Box>
  );
}
